module.exports = __webpack_public_path__ + "img/636901101341462268.2109d65a.gif";